import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=e8bcac6a&scoped=true&"
import script from "./Relatorio.vue?vue&type=script&lang=js&"
export * from "./Relatorio.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio.vue?vue&type=style&index=0&id=e8bcac6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bcac6a",
  null
  
)

export default component.exports